import type { FaireProductEntity } from "../../entity_types/product";

export const p_qmhpzv3fmc: FaireProductEntity = {
  token: "p_qmhpzv3fmc",
  type: "product",
  name: "Women's Soft Plush Cozy Wrap Robe with Belt",
  brandToken: "b_br6ji29u",
  brandName: "Softies",
  imageUrl: "https://cdn.faire.com/fastly/3b064a47dcd32dbd53819b1bcc87f44a2413857e5883ca92ef53780de42d9b0e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2a68fb695ad99fb130d6cd785cffce3ddc6c3ca5337d14f854657d50f14247b5.jpeg",
    "https://cdn.faire.com/fastly/94b4ed1c47a3dcff577f72d45379221db6378bfc42b59578749de2d84bc88859.png",
    "https://cdn.faire.com/fastly/6cb6574afdeab2f7ae01a18420c67376cc2a083268d4ce7af8f1c9b0d221ba8b.jpeg",
    "https://cdn.faire.com/fastly/27d0c98cd7869833fa696ad3e71b6be0950ab9a5ef8992abe580a392d5e1097a.jpeg",
    "https://cdn.faire.com/fastly/5d91b4690366f247f23f9cd4435ea1393bae05dd370b8d1e74baf7496d2141ea.jpeg",
    "https://cdn.faire.com/fastly/cfa8e57ff71e0c224945f86cdb43263faefc8c941afa6851f74a3654fbd1bda5.jpeg",
    "https://cdn.faire.com/fastly/07b8f0468770bafb2850215bff47366c13834b7b97331fed67057899e587910c.png",
    "https://cdn.faire.com/fastly/c5af3bb3d163c05dd75b07e13ec3b9de7a152115fe33dae5c272e7edf355ce1f.jpeg",
    "https://cdn.faire.com/fastly/2b11f9f22effc10be267090d9606048ef14e5638a6775e4c7c53f330f79983b7.jpeg",
    "https://cdn.faire.com/fastly/dd279a54bfb33c4cf25a4f63221a654a7403a8c4365b92a845132ceb30cb3fb3.jpeg",
    "https://cdn.faire.com/fastly/9b730dd4afefae06141c463251a07cb8f16577cd34f5df2dd33417235a5c0cf8.png"
  ],
  priceDollars: 60,
  description: "Wrap yourself in pure comfort. Made from our signature DreamPlush fabric, this robe delivers next-level softness with a velvety touch that feels like a warm embrace. The classic wrap silhouette features a shawl collar, self-tie belt, and relaxed fit for an effortlessly cozy feel. Perfect for slow mornings, spa nights, or post-shower lounging, it’s a must-have addition to any cold-weather collection or gifting assortment.\n\n𝐅𝐞𝐚𝐭𝐮𝐫𝐞𝐬:\n• Classic wrap-style robe with a relaxed, cozy fit\n• Includes a self-tie belt for adjustable fit and easy wear\n• A standout piece for holiday gifting, resort/spa edits, and cold-weather assortments\n• Pairs well with matching slippers or lounge sets for a full cozy look\n\n𝐌𝐚𝐭𝐞𝐫𝐢𝐚𝐥𝐬 & 𝐂𝐚𝐫𝐞:\n• Fabric: Made from ultra-soft, velvety DreamPlush fabric for a cozy, elevated feel\n• Fabric Content: 100% Polyester\n• Machine Washable\n• For best results: Turn inside out, wash cold, and line dry or tumble dry on low heat",
  tags: [],
  msrpDollars: 135,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-02T03:47:07.220Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
